// extracted by mini-css-extract-plugin
export default {"menuBtn":"burger-menu_menuBtn__kqQas","menuBtnBurger":"burger-menu_menuBtnBurger__jLJXp","open":"burger-menu_open__usFF2"};